<div class="p-4 md:p-0">
    <div class="max-w-3xl">
        <div class="text-3xl font-bold tracking-tight">Translation Settings</div>
        <div class="mt-2 text-secondary">Manage translation settings for this destination.</div>

        <div class="mt-8 p-6 bg-card rounded-2xl shadow">
            <mat-slide-toggle
                [checked]="destination.bl_translationdisabletitle"
                (change)="destination.bl_translationdisabletitle = $event.checked; onSave()"
                [disabled]="reviewMode">
                Disable Title Translation
            </mat-slide-toggle>
            <div class="text-sm text-secondary mt-2">
                When enabled, the title of this destination will not be translated by automated services.
            </div>
        </div>
    </div>
</div>
